import $ from 'jquery'
import 'slick-carousel/slick/slick'

const sliderSelector = '.js-slider';
const blockElements = document.querySelectorAll( sliderSelector );

blockElements.forEach((sliderBlock) => {
  const attributes = JSON.parse(sliderBlock.getAttribute('data-attributes'));
  const { blockId, slidesToShow, slidesToScroll, arrows, dots, infinite, autoplay, focusOnSelect, autoplaySpeed } = attributes;

  // Initialize Slick only if it hasn't already been initialized
  if (!$(sliderBlock).hasClass('slick-initialized')) {
    $(sliderBlock).slick({
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
      infinite: infinite,
      dots: dots,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      focusOnSelect: focusOnSelect,
      pauseOnHover: true,
      pauseOnFocus: true,
      prevArrow: arrows ? `.prev-arrow-${blockId}` : '',
      nextArrow: arrows ? `.next-arrow-${blockId}` : '',
      adaptiveHeight: true
    });
  }
})
